









































































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import AntecipacaoRecebiveisStore from '../financeiro/Store/AntecipacaoRecebiveisStore'

@Component
export default class AgendaGarantiaMinimaRightNavBar extends Vue {
  $refs!: {
    menuSolicitadoInicio: any
    menuSolicitadoFim: any
  }

  menuSolicitadoInicio: boolean = false
  menuSolicitadoFim: boolean = false
  filterLoading: boolean = false

  get getStore() {
    return getModule(AntecipacaoRecebiveisStore, this.$store)
  }

  get drawer() {
    return this.getStore.drawer
  }

  set drawer(value: boolean) {
    this.getStore.setDrawer(value)
  }

  get hospitaisList() {
    return this.getStore.locaisExecucaoList
  }

  get selectedHospital() {
    return this.getStore.selectedHospital
  }

  set selectedHospital(value) {
    this.getStore.setSelectedHospital(value)
  }

  get solicitadoInicio() {
    return this.getStore.solicitadoInicio
  }

  set solicitadoInicio(value) {
    this.getStore.setSolicitadoInicio(value)
  }

  get solicitadoFim() {
    return this.getStore.solicitadoFim
  }

  set solicitadoFim(value) {
    this.getStore.setSolicitadoFim(value)
  }

  async search() {
    this.filterLoading = true
    this.getStore.setPagina(1)
    this.getStore.getAllAntecipacoes()
    this.getStore.setFilterOn(this.hasAnyFilter())
    this.filterLoading = false
  }

  hasAnyFilter(): boolean {
    return (
      !!this.getStore.selectedHospital
      || !!this.getStore.solicitadoInicio
      || !!this.getStore.solicitadoFim
    )
  }

  async clear() {
    this.getStore.clearFiltroAvançado()
    this.getStore.setFilterOn(false)
    await this.search()
  }
}
